import React from 'react';
import StructureControl from "../../../../../core/gd/structure-control/structure-control";
import Checkbox, {CheckboxSize, CheckboxType} from '../../../../../core/gd-components/checkbox/checkbox';
import FormOwnerSelector from "./components/owner/owner-selector";
// @ts-ignore
import FormDeadlineSelector from "./components/deadline/deadline-selector";
// @ts-ignore
import FormStartEndSelector from "./components/start-end/start-end-selector";
// @ts-ignore
import FormTemplateCopyOptions from "./components/template-copy/template-copy-options";
import FormNameColorSelector from "./components/name-color/name-color-selector";
import FormDefaultViewSelector from "./components/default-view/default-view-selector";
import FormParentSelector from "./components/parent/parent-selector";
import {ProjectSystemType} from "../../../../../core/model2/project/types";
import {ViewType} from "../../../../../core/gd/const/views/view-type";
import AdvancedSwitch from "./components/advanced-switch/advanced-switch"

export type NewProjectFormProtoProps = {
    app                 : any
    initParams          : any
    redirected?         : boolean
    onProjectCreated?   : callback

    template?           : any // ???
}

type State = {
    companyId               : ID
    copyToMyTemplates       : boolean
    parentProjectId?        : ID
    colorSelectedManually   : boolean
    advanced                : boolean
}

export default class NewProjectFormProto extends React.Component<NewProjectFormProtoProps, State> {

    public systemType       : ProjectSystemType
    public form             : any // Form manager ?
    public initProjectId?   : ID
    public initDefaultView? : ViewType | null
    public defaultColor     : number = 6

    constructor(props:NewProjectFormProtoProps, systemType:ProjectSystemType) {
        super(props);

        this.systemType = systemType;
        this.form = null;

        // initial state
        const { initParams } = this.props;
        const { projectId } = initParams;
        const initProject = projectId ? gd.session.projects.get(projectId) : null;

        let companyId = initProject ? initProject.companyId : null;
        if (!companyId) companyId = initParams && initParams.company ? initParams.company : gd.companyId;

        // const initCompanyId = this.checkInitCompany(companyId);
        const initProjectId = this.checkInitProject(initProject);

        // defautl value for copy to my tpl
        let copyToMyTemplates = false;
        if (gd.ac.check.company.isManager(companyId)) {
            copyToMyTemplates = _.get(this.props.template, 'copyToLocalTemplate', false);
        }

        this.state =  {
            companyId               : gd.companyId,
            parentProjectId         : initProjectId,
            colorSelectedManually   : false,
            advanced                : this.props.app.localSettings.projectView === 'advanced',

            copyToMyTemplates       : copyToMyTemplates
        };

        // init Form Data
        this.initProjectId = initProjectId;
        this.initDefaultView = null;

        this.defaultColor = this.initProjectId ?
            gd.session.projects.get(this.initProjectId)!.color
            :
            _.get(gd.session.me, 'clientData.color', 6);
    }

    // need it for now... inretireted componets use it...
    // @ts-ignore
    _bind(...methods) {
        methods.forEach((method)=>{
            try {
                // @ts-ignore
                this[method] = this[method].bind(this);
            } catch(err) {
                console.error("BaseComponent","_bind error:", method, err);
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps:NewProjectFormProtoProps) {
        const { initParams } = nextProps;
        const { projectId } = initParams;
        const initProject = projectId ? gd.session.projects.get(projectId) : null;

        let companyId = initProject ? initProject.companyId : null;
        if (!companyId) companyId = initParams && initParams.company ? initParams.company : gd.companyId;

        if ((companyId !== this.state.companyId || projectId !== this.state.parentProjectId)) {
            this.form.setFieldValue("company", this.checkInitCompany(companyId));
            this.form.setFieldValue("parentProject", this.checkInitProject(initProject));
            this.onParentChange();
        }
    }

    checkInitCompany = (initCompanyId:ID | null) => {
        if (!initCompanyId) return null
        return gd.ac.check.createRootProject() ? initCompanyId : null
    }

    checkInitProject = (initProject:any) => {
        if (!initProject) return null

        let initProjectId = initProject.id
        const allowedParentTypes = StructureControl.newParentOptions(this.systemType)
        initProjectId = allowedParentTypes.includes(initProject.systemType) && !initProject.isTemplate ? initProjectId : null

        const project = gd.session.projects.get(initProjectId)
        if (!project?.acl.canCreateProject) initProjectId = null

        return initProjectId
    }

    onSwitchAdvanced = (id:string) => {
        const isAdvanced = id === 'advanced';

        this.props.app.localSettings.projectView = isAdvanced ? 'advanced' : 'simple';
        this.props.app.localSettings.save();

        this.setState({
            advanced: isAdvanced
        });
    }

    onParentChange = () => {
        this.setState({
            companyId: this.form.getValue('company'),
            parentProjectId: this.form.getValue('parentProject')
        })
    }

    onParentSelected = (projectId: ID) => {

        this.form.setFieldValue("company", gd.companyId);
        this.form.setFieldValue("parentProject", projectId);

        if (!this.state.colorSelectedManually && projectId) {
            const parentColor = gd.session.projects.get(projectId)!.color;

            this.form.setFieldValue("color", parentColor);
            this.form.fields.color.component.forceUpdate(); //why not just go with setstate for form ? :)
        }

        this.onParentChange();
    }

    // COPY OPTIONS FORM TEMPLATE
    onCopyOptionSelect = (id:ID) => {
        let newSelectedOptions = this.form.getValue('copyOptions');
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,id);
        this.form.setValue('copyOptions', newSelectedOptions);
    }

    // Submit
    onProjectCreated(data:any, callback?: func) {
        const { app, onProjectCreated } = this.props;
        this.form.reset();
        this.form.setFieldValue('name','');

        if (onProjectCreated) onProjectCreated();
        app.render();

        const project = gd.session.projects.get(data.projectId)!;

        if (this.props.app.initParams.onNewProjectCallback) this.props.app.initParams.onNewProjectCallback(project)
        else  if (callback)                                 callback(project)
        else                                                gd.goTo(project.url)
    }


    onClickCopyToMyTemplates = () => {
        this.setState({
            copyToMyTemplates: !this.state.copyToMyTemplates
        })
    }

    renderAdvancedSwitch() {
        return <AdvancedSwitch advanced         = {this.state.advanced}
                               onSwitchAdvanced = {this.onSwitchAdvanced}/>
    }

    renderSelectParent() {
        const filterProjects = _.map(gd.session.projects.models, project =>({
            item            : project,
            notSelectable   : !project.canCreateProject()
        }))

        return <FormParentSelector form                 = {this.form}
                                   parentProjectId      = {this.state.parentProjectId}
                                   allowRootSelection   = {gd.user.acl.canCreateRootProject}
                                   filterProjects       = {filterProjects}
                                   onParentSelected     = {this.onParentSelected}/>
    }

    renderNameAndColor()        {return <FormNameColorSelector      form={this.form}/>}
    renderDefaultView()         {return <FormDefaultViewSelector    form={this.form} systemType={this.systemType}/>}
    renderOwner()               {return <FormOwnerSelector          form={this.form} />}
    renderDeadline()            {return <FormDeadlineSelector       form={this.form}/>}
    renderStartEnd()            {return <FormStartEndSelector       form={this.form}/>}
    renderTemplateCopyOptions() {return <FormTemplateCopyOptions    form={this.form} template={this.props.template} onCopyOptionSelect={this.onCopyOptionSelect}/>}

    // copy to my template
    renderCopyToMyTemplates() {
        if (gd.ac.check.company.isManager(gd.companyId)) {
            return (
                <div className="row">
                    <div className="label">Add to My Templates</div>
                    <div className="element checkbox">
                        <Checkbox size={CheckboxSize.NORMAL}
                                  type={CheckboxType.FILLED}
                                  isChecked={this.props.redirected || this.state.copyToMyTemplates}
                                  disabled={this.props.redirected}
                                  onClick={this.onClickCopyToMyTemplates} />
                    </div>
                </div>
            )
        }

        return false;
    }

    render(): any {return null;}
}
